<template>
    <my-dialog title="销售订单详情" dialogType="form" :visible.sync="showDialog" :close-on-click-modal="false"
        @close="closeDialog" width="80%">
        <div class="main_bg">
            <div class="item_info border_Warningcolor">
                <el-descriptions class="margin-top" title="订单信息" :column="3" border>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            所属门店
                        </template>
                        {{ editForm.storeName }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            订单号
                        </template>
                        {{ editForm.code }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            订单来源
                        </template>
                        {{ editForm.orderSourceStr }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            经办人
                        </template>
                        {{ editForm.creator }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            经办时间
                        </template>
                        {{ editForm.createTime }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            订单状态
                        </template>
                        {{ editForm.stateStr }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            是否确认
                        </template>
                        {{ editForm.isConfirm ? '是' : '否' }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            确认人
                        </template>
                        {{ editForm.confirmUserName }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            确认时间
                        </template>
                        {{ editForm.confirmDate }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            商品总额
                        </template>
                        {{ editForm.totalProductMoney }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            收费金额
                        </template>
                        {{ editForm.totalMoney }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            总支付金额
                        </template>
                        {{ editForm.totalPayMoney }}
                    </el-descriptions-item>
                    <el-descriptions-item span="3">
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            备注
                        </template>
                        {{ editForm.remark }}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="item_info">
                <el-descriptions class="margin-top" title="顾客信息" :column="6" border>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-user"></i>
                            顾客姓名
                        </template>
                        {{ transformEmpty(customerInfo.name) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-office-building"></i>
                            性别
                        </template>
                        {{ transformGender(customerInfo.gender) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            年龄
                        </template>
                        {{ transformEmpty(customerInfo.age) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-mobile-phone"></i>
                            顾客电话
                        </template>
                        {{ transformEmpty(customerInfo.phone) }}
                    </el-descriptions-item>
                    <el-descriptions-item span="3">
                        <template slot="label">
                            <i class="el-icon-location-outline"></i>
                            所属门店
                        </template>
                        {{ transformEmpty(customerInfo.belongStoreName) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            (右眼)球镜
                        </template>
                        {{ transformEmpty(customerInfo.rParams.qiuJing) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            柱镜
                        </template>
                        {{ transformEmpty(customerInfo.rParams.zhuJing) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            轴位
                        </template>
                        {{ transformEmpty(customerInfo.rParams.zhouWei) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            瞳高
                        </template>
                        {{ transformEmpty(customerInfo.rParams.tongGao) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            瞳距
                        </template>
                        {{ transformEmpty(customerInfo.rParams.tongJu) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            矫正视力
                        </template>
                        {{ transformEmpty(customerInfo.rParams.jiaoZhengShiLi) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            (左眼)球镜
                        </template>
                        {{ transformEmpty(customerInfo.lParams.qiuJing) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            柱镜
                        </template>
                        {{ transformEmpty(customerInfo.lParams.zhuJing) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            轴位
                        </template>
                        {{ transformEmpty(customerInfo.lParams.zhouWei) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            瞳高
                        </template>
                        {{ transformEmpty(customerInfo.lParams.tongGao) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            瞳距
                        </template>
                        {{ transformEmpty(customerInfo.lParams.tongJu) }}
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <i class="el-icon-tickets"></i>
                            矫正视力
                        </template>
                        {{ transformEmpty(customerInfo.lParams.jiaoZhengShiLi) }}
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="item_info border_Green">
                <div class="item_title">
                    <div class="title">商品信息</div>
                    <div class="btnDiv">

                    </div>
                </div>
                <el-table :data="salesOrderDtlData" border stripe style="width: 100%;border-radius: 10px;"
                    :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
                    :cell-style="{ textAlign: 'center' }">
                    <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
                    <el-table-column prop="typeName" label="类型名称" width="120"></el-table-column>
                    <el-table-column prop="productName" label="商品名称"></el-table-column>
                    <el-table-column prop="specification" label="规格"></el-table-column>
                    <el-table-column prop="price" label="单价" width="90"></el-table-column>
                    <el-table-column prop="quantity" label="数量" width="90"></el-table-column>
                    <el-table-column prop="money" label="金额" width="90"></el-table-column>
                    <el-table-column prop="util" label="单位" width="60"></el-table-column>
                </el-table>
            </div>
            <div class="item_info border_Danger">
                <div class="item_title">支付记录</div>
                <div class="btnDiv">

                </div>
                <payRecord ref="payRecord"></payRecord>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">关闭</el-button>
        </div>
    </my-dialog>
</template>
<script>
import {
    GetSalesOrderDetail
} from "@/api/productApi.js";
import {
    getCustomerInfoDetail
} from "@/api/baseDataApi.js";
import {
    GetEnumConfigListByCode
} from "@/api/enumApi.js";
import payRecord from "@/views/pay/record.vue";
export default {
    props: [],
    data() {
        return {
            showDialog: false,
            editForm: {
            },
            customerInfo: {
                name: "",
                phone: "",
                age: "",
                gender: -1,
                belongStoreName: "",
                lParams: {
                    qiuJing: "",
                    zhuJing: "",
                    zhouWei: "",
                    jiaoZhengShiLi: "",
                    tongJu: "",
                    tongGao: "",
                },
                rParams: {
                    qiuJing: "",
                    zhuJing: "",
                    zhouWei: "",
                    jiaoZhengShiLi: "",
                    tongJu: "",
                    tongGao: "",
                },
            },
            salesOrderDtlData: [],
        };
    },
    components: {
        payRecord
    },
    created() { },
    methods: {
        // 显示
        getDetailDialog(row) {
            this.showDialog = true;
            GetSalesOrderDetail({
                keyId: row.keyId,
            }).then((res) => {
                if (res.code == 1) {
                    getCustomerInfoDetail({ keyId: res.data.customerKeyId }).then(
                        (res) => {
                            if (res.code == 1) {
                                this.customerInfo = res.data;
                            } else {
                                this.$message({
                                    type: "error",
                                    message: res.msg,
                                });
                            }
                        }
                    );
                    this.editForm = res.data;
                    this.salesOrderDtlData = res.data.dtls;
                    this.$refs.payRecord.showPayReord(row.keyId);
                } else {
                    this.$message({
                        type: "error",
                        message: res.msg,
                    });
                }
            });
        },
        //转换性别
        transformGender(gender) {
            if (gender == 1) {
                return "男";
            } else if (gender == 0) {
                return "女";
            } else {
                return "--";
            }
        },
        //判断为空则用 -- 替代
        transformEmpty(obj) {
            if (obj == "" || obj == null || obj == undefined) {
                obj = "--";
            }
            return obj;
        },
        // 关闭
        closeDialog() {
            this.showDialog = false;
        },
    },
};
</script>
<style scoped lang="scss">
.main_bg {
    padding: 10px;
    margin-top: -15px;
}

.item_info {
    border-left: 5px solid #55aaff;
    padding: 5px 10px;
    border-radius: 5px;
    margin-bottom: 15px;
    border-bottom: 2px solid #e9e7e7;
}

.border_Warningcolor {
    border-left: 5px solid #ff9900;
}

.border_Green {
    border-left: 5px solid #00cc66;
}

.border_Danger {
    border-left: 5px solid #ff0000;
}

.item_title {
    display: flex;
    width: 100%;
    font-weight: 700;
    font-size: 1rem;
    margin-bottom: 10px;
    justify-content: space-between;

    .title {
        display: inline-block;
        unicode-bidi: isolate;
    }

    .btnDiv {
        display: block;
        unicode-bidi: isolate;
        word-break: break-all;
    }

    .btnDivItem {
        display: inline-block;
    }

    .text-red {
        display: block;
        background-color: #ff0000;
    }
}
</style>